import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { IDashboardParams } from "../../interface";
import { axiosProperty, throwResponse } from "config/axios";
import { ISurvey } from "./interface";

export const useGetPropertyDashboardSurvey = (
  params?: IDashboardParams
): UseQueryResult<ISurvey[], Error> => {
  return useQuery(
    ["dashboard-property-survey", "count-on-menu", params],
    async () => {
      const res = await axiosProperty.get(
        "dashboard/satisfaction-survey/count-on-menu",
        { params }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};
